var _circle, _rect, _path, _path2, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#10C6A5",
    fillOpacity: 0.15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 5.5,
    width: 14,
    height: 17.75,
    rx: 2.5,
    stroke: "#10C6A5",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#10C6A5",
    d: "M8.625 7.625h13.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#10C6A5",
    strokeLinecap: "round",
    d: "M12.5 10.5h7.125M12.5 19.5h7.125M12.5 16.5h7.125M12.5 13.5h7.125"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.375,
    cy: 10.5,
    r: 0.5,
    fill: "#10C6A5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 16.5,
    r: 0.5,
    fill: "#10C6A5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 19.5,
    r: 0.5,
    fill: "#10C6A5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 13.5,
    r: 0.5,
    fill: "#10C6A5"
  })));
}
export default SvgForms;